import React from "react";
import PageNavigation from "../components/PageNavigation";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/Button";
import { Plus, Globe } from "lucide-react";
import { Link } from "react-router-dom";

const PageList: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Dynamic Pages</h1>
              <p className="text-gray-600 mt-1">Manage and view all published pages</p>
            </div>
            <div className="flex items-center gap-3">
              <Link to="/admin/editor/terms">
                <Button variant="outline">
                  <Plus className="h-4 w-4 mr-2" />
                  Manage Pages
                </Button>
              </Link>
              <Button>
                <Globe className="h-4 w-4 mr-2" />
                View All
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <PageNavigation />
      </div>
    </div>
  );
};

export default PageList;
